<script>
    import {onMount} from "svelte";
    import Assessment from '../Models/assessmentModel';
    import Notepad from "./Notepad.svelte";
    import {debounce} from "lodash-es";

    let assessment;

    onMount(async () => {
        let assessment_id = window.location.hash.split('/')[2];
        let assessment_details = await Assessment.getAssessmentDetails(assessment_id);
        let assessment_model;

        assessment_model = new Assessment(assessment_details);
        assessment = assessment_model.store;

        window.onresize = debounce((evt) => {
            window.localStorage.setItem(`notepad_popup_size`, JSON.stringify({
                height: window.innerHeight,
                width: window.innerWidth
            }))
        }, 500);
    });
</script>

{#if $assessment}
    <Notepad assessment={$assessment} isPopup />
{/if}